import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
} from "@arcadeai/design-system/components/ui/atoms/select";
import type { ReactNode } from "react";
import { getClientIdsForAuthType, MCP_CLIENTS } from "../client-config";
import type { McpAuthType, McpClientId } from "../types";

type ClientSelectorProps = {
  value: McpClientId;
  onChange: (value: McpClientId) => void;
  authType: McpAuthType;
};

type ClientOptionContentProps = {
  logo?: ReactNode;
  name: string;
};

function ClientOptionContent({ logo, name }: ClientOptionContentProps) {
  return (
    <span className="flex items-center gap-2">
      {!!logo && (
        <span className="flex size-4 shrink-0 items-center justify-center [&>svg]:size-4">
          {logo}
        </span>
      )}
      {name}
    </span>
  );
}

export function ClientSelector({
  value,
  onChange,
  authType,
}: ClientSelectorProps) {
  const clientIds = getClientIdsForAuthType(authType);

  if (clientIds.length === 0) {
    return null;
  }

  const selectedClient = MCP_CLIENTS[value];

  return (
    <Select
      onValueChange={(next) => {
        if (next != null) {
          onChange(next);
        }
      }}
      value={value}
    >
      <SelectTrigger className="w-[200px]">
        <ClientOptionContent
          logo={selectedClient.logo}
          name={selectedClient.name}
        />
      </SelectTrigger>
      <SelectContent>
        {clientIds.map((clientId) => {
          const client = MCP_CLIENTS[clientId];
          return (
            <SelectItem key={clientId} value={clientId}>
              <ClientOptionContent logo={client.logo} name={client.name} />
            </SelectItem>
          );
        })}
      </SelectContent>
    </Select>
  );
}
